export default function NoMatch() {
	return (
		<div id="exemptions-portal--no-match" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">
						That page could not be found.
					</h1>
				</div>
			</div>
		</div>
	);
}